export enum AppVersionPlatformEnum {
  IOS = "ios",
  ANDROID = "android",
  BACKOFFICE = "backoffice",
}

export interface AppVersion {
  _id?: string;
  platform: AppVersionPlatformEnum;
  version: string;
  apiVersion: string;
  functionalVersion: string;
  isCurrent: boolean;
  releaseNotes: string;
  storeUrl?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface CurrentAppVersion {
  version: string;
  apiVersion: string;
  functionalVersion: string;
}

export interface CreateAppVersionPayload {
  platform: AppVersionPlatformEnum;
  version: string;
  apiVersion: string;
  functionalVersion: string;
  releaseNotes: string;
  storeUrl?: string;
}

export interface UpdateAppVersionPayload extends CreateAppVersionPayload {
  _id: string;
}

export interface GetAppVersionsParams {
  isCurrent?: boolean;
  platform?: AppVersionPlatformEnum;
}
